import { Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core'
import { UtilsService } from '@shared/services/utils.service'
import { fromEvent, Subject, takeUntil } from 'rxjs'

@Directive({
	selector: '[inputNumberSigns]',
})
export class InputNumberSignsDirective implements OnInit, OnDestroy {
	private readonly _elementRef: ElementRef<HTMLInputElement> = inject<ElementRef<HTMLInputElement>>(ElementRef)
	private readonly _utilsService: UtilsService = inject<UtilsService>(UtilsService)

	private _destroy$: Subject<void> = new Subject<void>()

	private _listenInput(): void {
		const inputEl: HTMLInputElement = this._elementRef.nativeElement
		const attributes: NamedNodeMap = inputEl.attributes

		const isInputNumber: boolean = !!(
			attributes.getNamedItem('type')?.value === 'number' || attributes.getNamedItem('tuiinputnumber')
		)
		if (!isInputNumber) return

		fromEvent<KeyboardEvent>(inputEl, 'keydown')
			.pipe(takeUntil(this._destroy$))
			.subscribe((event: KeyboardEvent): void => {
				this._utilsService.inputSigns(event)
			})
	}

	ngOnInit(): void {
		this._listenInput()
	}

	ngOnDestroy(): void {
		this._destroy$.next()
		this._destroy$.complete()
	}
}
